// Central map of backend endpoints used by the SuperAdmin frontend
// ⚠️  Keep keys alphabetical for easier grep
const apiPrefix = '/api/v1';
// Central map of backend endpoints used by the SuperAdmin frontend
// ⚠️  Keep keys alphabetical for easier grep
export const ep = {
  // auth
  authLogin: `${apiPrefix}/auth/login`,
  authLogout: `${apiPrefix}/auth/logout`,
  authRefresh: `${apiPrefix}/auth/refresh`,
  currentUserContext: `${apiPrefix}/users/current`,

  // invitations (public)
  inviteAccept: `${apiPrefix}/public/invitations/accept`,

  // dashboard resources (super admin prefix)
  tenants: `${apiPrefix}/super/tenants`,
  users: `${apiPrefix}/super/users`,
  logs: `${apiPrefix}/super/logs`,
  supportAccessCatalog: `${apiPrefix}/super/access/catalog`,
  supportAssignments: `${apiPrefix}/super/location-assignments`,
  supportActions: `${apiPrefix}/super/support-actions`,
  managers: (tenantId: string) => `${apiPrefix}/super/tenants/${tenantId}/managers`,
  search: `${apiPrefix}/super/search`,

  // invitations
  inviteManager: (tenantId: number) => `${apiPrefix}/super/tenants/${tenantId}/invite`,

  // nested resources
  tenantLocations: (t: string) => `${apiPrefix}/super/tenants/${t}/locations`,
  locationSpaces: (l: string) => `${apiPrefix}/super/locations/${l}/spaces`,
  spaceTables: (s: string) => `${apiPrefix}/super/spaces/${s}/tables`,
  tenantReservations: (t: string) => `${apiPrefix}/super/tenants/${t}/reservations`,
  tenantTableReservations: (t: string) => `${apiPrefix}/super/tenants/${t}/table-reservations`,
} as const;
